<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-06-27 16:19:44
 * @LastEditors: yuka
 * @LastEditTime: 2019-08-09 10:57:48
 * @Description: 官网首页
 -->

<template>
  <div class="m-bank-wrapper">
    <img src="https://files.jinr.com/jinr-index/img/bank-content-01.png" alt="" srcset="" />
    <img src="https://files.jinr.com/jinr-index/img/bank-content-02.png" alt="" srcset="" />
  </div>
</template>
<script>
export default {};
</script>
<style lang="less" scope>
.m-bank-wrapper {
  padding: 0.4rem 0 0;
  img {
    width: 100%;
    margin: 0.3rem 0 0;
  }
}
</style>
